<template>
  <div class="error-page">
    <h2 class="headline text-yellow"> 404</h2>

    <div class="error-content">
      <h3><i class="fa fa-warning text-yellow"></i> {{ $t('not_found.text') }}</h3>

      <p>{{ $t('not_found.back_1') }}
        <router-link :to="{ name: 'login' }">{{ $t('not_found.back_2') }}</router-link>
        .
      </p>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
  h3 {
    padding-top: 40px;
  }

  .error-content > * {
    margin-left: 20px;
  }
</style>
